import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, fmtDate, getUser, CUSTOMS_STATUS, stBadge } from '../api';
import { Modal, useToast, Loading, ErrorBox, rowNav } from '../ui';
import { Icons } from '../icons';

export default function Customs() {
  const [list, setList] = useState<any[] | null>(null);
  const [err, setErr] = useState('');
  const [creating, setCreating] = useState(false);
  const [openOrders, setOpenOrders] = useState<any[]>([]);
  const [sel, setSel] = useState<number[]>([]);
  const nav = useNavigate();
  const toast = useToast();
  const user = getUser();
  const canEdit = ['admin', 'rastamojka'].includes(user?.role);

  const load = () => { setErr(''); api.get('/customs').then(setList).catch((e) => { setErr(e.message); setList([]); }); };
  useEffect(() => { load(); }, []);

  const startCreate = async () => {
    setCreating(true); setSel([]);
    try {
    const [partial, received, transit, decls] = await Promise.all([
      api.get('/orders?status=partial'),
      api.get('/orders?status=received'),
      api.get('/orders?status=in_transit'),
      api.get('/customs'),
    ]);
    // allaqachon faol deklaratsiyaga ulangan zakazlar taklif qilinmaydi
    const taken = new Set<number>();
    decls.forEach((d: any) => { if (d.status !== 'archive') d.orders.forEach((o: any) => taken.add(o.orderId ?? o.order?.id)); });
    setOpenOrders([...received, ...partial, ...transit].filter((o: any) => !taken.has(o.id)));
    } catch (e: any) { toast(e.message, true); setOpenOrders([]); }
  };
  const create = async () => {
    try {
      const r = await api.post('/customs', { orderIds: sel, date: new Date().toISOString() });
      toast('Rastamojka hujjati yaratildi'); nav('/customs/' + r.id);
    } catch (e: any) { toast(e.message, true); }
  };
  const remove = async (e: React.MouseEvent, c: any) => {
    e.stopPropagation();
    if (!confirm(`${c.number} rastamojka hujjati o'chirilsinmi?`)) return;
    try { await api.del('/customs/' + c.id); toast("O'chirildi"); load(); }
    catch (err: any) { toast(err.message, true); }
  };

  return (
    <div>
      <div className="page-head">
        <div><h1 className="page-title">Rastamojka</h1><p className="page-sub">{list ? list.length : '—'} ta hujjat</p></div>
        {canEdit && <button className="btn btn-primary" onClick={startCreate}>+ Yangi rastamojka</button>}
      </div>
      {err ? <ErrorBox text={err} onRetry={load} /> : !list ? <Loading /> : (
        <div className="table-wrap">
          <table>
            <thead><tr><th>Raqam</th><th>GTD</th><th>Sana</th><th>Zakazlar</th><th className="num">Guruhlar</th><th>Status</th><th></th></tr></thead>
            <tbody>
              {list.map((c) => (
                <tr key={c.id} style={{ cursor: 'pointer' }} onClick={rowNav(() => nav('/customs/' + c.id))}>
                  <td className="code" style={{ color: 'var(--accent)' }}>{c.number}</td><td>{c.gtdNumber || '—'}</td>
                  <td>{fmtDate(c.date)}</td><td>{c.orders.map((o: any) => o.order.number).join(', ')}</td>
                  <td className="num">{c._count.items}</td>
                  <td><span className={'badge ' + stBadge(CUSTOMS_STATUS, c.status).cls}>{stBadge(CUSTOMS_STATUS, c.status).label}</span></td>
                  <td onClick={(e) => e.stopPropagation()}>{canEdit && <button className="act act-del" title="O'chirish" onClick={(e) => remove(e, c)}><Icons.trash size={16} /></button>}</td>
                </tr>
              ))}
              {list.length === 0 && <tr><td colSpan={7} className="empty">Hali hujjat yo'q</td></tr>}
            </tbody>
          </table>
        </div>
      )}
      {creating && (
        <Modal title="Yangi rastamojka hujjati" onClose={() => setCreating(false)}>
          <h4>Zakazlarni ulash</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 16 }}>
            {openOrders.length === 0 && <span className="muted">Ulash uchun zakaz yo'q</span>}
            {openOrders.map((o) => (
              <label key={o.id} className="chip" style={{ cursor: 'pointer', borderColor: sel.includes(o.id) ? 'var(--accent)' : undefined }}>
                <input type="checkbox" checked={sel.includes(o.id)} onChange={() => setSel(sel.includes(o.id) ? sel.filter((x) => x !== o.id) : [...sel, o.id])} />
                {o.number} · {o.supplier?.name || '—'} · {o.positions} poz.
              </label>
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <button className="btn" onClick={() => setCreating(false)}>Bekor</button>
            <button className="btn btn-primary" disabled={!sel.length} onClick={create}>Yaratish va guruhlash</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
